import * as angular from 'angular';

export const ServicesModule = angular.module('app.services', []);
